import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import MemberOpportunitiesPage from "@/pages/member/MemberOpportunitiesPage";

export const Route = createFileRoute("/member/opportunities")({
  head: () => pageHead("Member · Opportunities", "AKIVA member · opportunities portal.", "/member/opportunities", true),
  component: MemberOpportunitiesPage,
});
